import { PropsWithChildren } from 'react'

export function Title({ children }: PropsWithChildren) {
  return (
    <h5 className='font-body text-lg font-medium tracking-normal'>
      {children}
    </h5>
  )
}

export function Paragraph({ children }: PropsWithChildren) {
  return <p className='whitespace-pre-line text-sm'>{children}</p>
}
